const setCanvasDimensionsForImage = (canvas: HTMLCanvasElement, image: HTMLImageElement): void => {
   canvas.width = image.width;
   canvas.height = image.height;
};

const drawImageOnCanvas = (canvas: HTMLCanvasElement, image: HTMLImageElement): void => {
   canvas.getContext('2d').drawImage(image, 0, 0, image.width, image.height);
};

const getContainerStyling = (container: HTMLDivElement, canvas: HTMLCanvasElement): React.CSSProperties => {
   const style: React.CSSProperties = {};
   if (container.clientHeight > canvas.clientHeight) {
      style.display = 'flex';
      style.alignItems = 'center';
      style.justifyContent = 'center';
   }
   return style;
};

const getCanvasStyling = (container: HTMLDivElement, canvas: HTMLCanvasElement): React.CSSProperties => {
   return {flexBasis: container.clientWidth <= canvas.width ? '100%' : 'auto'}; // IE11 bug fix
};

export default {
   setCanvasDimensionsForImage,
   drawImageOnCanvas,
   getContainerStyling,
   getCanvasStyling
};
